var map = {
	"./common/zh-CN.js": 20508,
	"./email/zh-CN.js": 34123,
	"./nomination/zh-CN.js": 19947,
	"./supportTool/zh-CN.js": 45366,
	"./temp/zh-CN.js": 43315,
	"./winner/zh-CN.js": 29354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20822;